import React, { useEffect, useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Assignment } from "@material-ui/icons";
import ReactTable from "components/ReactTable/ReactTable.js";
import Card from "components/Card/Card";
import CardIcon from "components/Card/CardIcon";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import { Paper } from "@material-ui/core";

import { wsFindBy } from "services/WService";
import ModalFull from "components/Tvendo/Common/ModalFull";
import { WithApp } from "contexts/appContext";
import moment from "moment";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  detail: {
    display: "flex",
    alignItems: "center",
    "& span": {
      marginLeft: "10px",
      marginRight: "10px",
      color: "#000000bf",
      fontWeight: "bold",
      fontSize: "15px"
    }
  },
  paper: {
    padding: "0px 11px 4px 10px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    marginBottom: "5px"
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "Correlativo", accessor: "LineNum" },
  { Header: "Esta. Línea", accessor: "LineStatus" },
  { Header: "U/Mjo", accessor: "unitMsr" },
  { Header: "# pza", accessor: "NumPerMsr" },
  { Header: "Cód. producto", accessor: "ItemCode" },
  { Header: "Descripción", accessor: "Dscription" },
  { Header: "Cantidad", accessor: "Quantity" },
  { Header: "Precio", accessor: "Price" },
  { Header: "Precio/IGV", accessor: "PriceAfVAT" },
  { Header: "Total línea", accessor: "LineTotal" },
  { Header: "Mto. IGV", accessor: "VatSum" },
  { Header: "Total IGV", accessor: "GTotal" },
  { Header: "", accessor: "actions", excelEnabled: false }
];

export default WithApp(function DocumentDetailModal(props) {
  const classes = useStyles();

  const { title, openDetailId, open, setOpen } = props;

  const [document, setDocument] = useState({});
  const [documentDetails, setDocumentDetails] = useState([]);

  async function getOrderDetails() {
    let response = await wsFindBy(
      "sap/business-partner/document/" + openDetailId.DocEntry,
      {
        CardCode: openDetailId.CardCode,
        ObjType: openDetailId.ObjType
      }
    );
    if (response.success) {
      setDocument(response.data);
      setDocumentDetails(response.data.details);
    }
  }

  useEffect(() => {
    if (open) {
      getOrderDetails();
    }
  }, [open]);

  return (
    <ModalFull
      title={title + " -  " + document.CardName}
      open={open}
      setOpen={setOpen}
    >
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color={props.themeContext.buttonColor}>
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Detalle de Documentos</h4>
            </CardHeader>
            <CardBody>
              <GridContainer style={{ marginBottom: "15px" }}>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Vendedor: </h5>
                    <span>{document.SlpName}</span>
                  </Paper>
                </GridItem>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Total Doc: </h5>
                    <span>S/ {document.DocTotal}</span>
                  </Paper>
                </GridItem>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Pagado: </h5>
                    <span>S/ {document.PaidToDate}</span>
                  </Paper>
                </GridItem>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Fec. Doc: </h5>
                    <span>{moment(document.TaxDate).format("MM/DD/YYYY")}</span>
                  </Paper>
                </GridItem>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Mesa: </h5>
                    <span>{document.Mesa}</span>
                  </Paper>
                </GridItem>
              </GridContainer>

              <ReactTable
                excelName={
                  "Detalles-de-documentos-socio-" + openDetailId?.CardCode
                }
                defaultWidth={1800}
                indexRow={[
                  0,
                  1,
                  2,
                  3,
                  4,
                  5,
                  /* 6, */ 7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14
                ]}
                widthRow={[
                  80,
                  120,
                  120,
                  100,
                  100,
                  130,
                  /* 100, */
                  130,
                  120,
                  120,
                  120,
                  120,
                  120,
                  10
                ]}
                columns={columns}
                data={documentDetails.map((item, i) => {
                  return {
                    num: i + 1,
                    LineNum: item.LineNum,
                    LineStatus: item.LineStatus,
                    unitMsr: item.unitMsr,
                    NumPerMsr: item.NumPerMsr,
                    ItemCode: item.ItemCode,
                    Dscription: item.Dscription,
                    Quantity: item.Quantity,
                    Price: item.Price,
                    PriceAfVAT: item.PriceAfVAT,
                    LineTotal: item.LineTotal,
                    VatSum: item.VatSum,
                    GTotal: item.GTotal,
                    actions: ""
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </ModalFull>
  );
});
